import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { EditorialMarquee } from "../components/Marquee";
import { Manifesto } from "../components/Manifesto";
import { KitInitiative } from "../components/KitInitiative";
import { Impact } from "../components/Impact";
import { Programs } from "../components/Programs";
import { Reach } from "../components/Reach";
import { Gallery } from "../components/Gallery";
import { Partner } from "../components/Partner";
import { GetInvolved } from "../components/GetInvolved";
import { Footer } from "../components/Footer";

export default function Home() {
  return (
    <div className="grain">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <KitInitiative />
        <Impact />
        <Programs />
        <Reach />
        <Gallery />
        <Partner />
        <GetInvolved />
      </main>
      <Footer />
    </div>
  );
}
